const relativeTime = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

/** How long ago `value` was, such as "5 minutes ago" or "last month". */
export function formatTimeAgo(value: string): string {
  const seconds = Math.round((new Date(value).valueOf() - Date.now()) / 1000);
  if (Math.abs(seconds) < 60) return relativeTime.format(seconds, "second");
  const minutes = Math.round(seconds / 60);
  if (Math.abs(minutes) < 60) return relativeTime.format(minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return relativeTime.format(hours, "hour");
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 7) return relativeTime.format(days, "day");
  if (Math.abs(days) < 30) return relativeTime.format(Math.round(days / 7), "week");
  if (Math.abs(days) < 365) return relativeTime.format(Math.round(days / 30), "month");
  return relativeTime.format(Math.round(days / 365), "year");
}
